import { render, staticRenderFns } from "./UserChangeLogsTab.vue?vue&type=template&id=03544a1a&scoped=true"
import script from "./UserChangeLogsTab.vue?vue&type=script&lang=js"
export * from "./UserChangeLogsTab.vue?vue&type=script&lang=js"
import style0 from "./UserChangeLogsTab.vue?vue&type=style&index=0&id=03544a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03544a1a",
  null
  
)

export default component.exports